var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { assert } from '@ember/debug';
// The back-end inserts these props into current user data to mark where web
// permissions start/end. Any props between them are added to this service.
const START_MARKER_PROP = 'startWebPermissions';
const END_MARKER_PROP = 'endWebPermissions';
let UserWebPermissions = (_dec = readOnly('currentUserData.data'), _class = class UserWebPermissions extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUserData", _descriptor, this);
    _initializerDefineProperty(this, "data", _descriptor2, this);
    _defineProperty(this, "canHasCompletedPayrollOnboarding", void 0);
    _defineProperty(this, "canUseHouseAccounts", void 0);
    _defineProperty(this, "canUseThirdPartyGiftCardProvider", void 0);
    _defineProperty(this, "canSeeBills", void 0);
    _defineProperty(this, "canIgnoreItemsBulkObjectLimit", void 0);
    _defineProperty(this, "canViewGiftCardHistoryEvents", void 0);
    _defineProperty(this, "canPrintLogoOnPaperDashboard", void 0);
    _defineProperty(this, "canMultiunit", void 0);
    _defineProperty(this, "canAcceptAllTransactionAmounts", void 0);
    _defineProperty(this, "canShowThirdPartyGiftCardProviderOnboarding", void 0);
    const keys = Object.keys(this.data) || [];
    const startIndex = keys.indexOf(START_MARKER_PROP) + 1;
    const endIndex = keys.indexOf(END_MARKER_PROP) - 1;
    if (startIndex === -1 || endIndex === -1 || startIndex > endIndex) {
      // this should Never Happen™, but if it does then the data is meaningless
      assert('Current user data does not have start/end marker props for web permissions');
      return;
    }

    // hashtable object with string keys and boolean values
    const props = {};
    for (let i = startIndex; i <= endIndex; i++) {
      const key = keys[i];
      props[key] = this.data[key];
    }

    // yes, this is cheating typescript
    Object.assign(this, props);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { UserWebPermissions as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.